"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Breakpoint = void 0;
var Breakpoint;
exports.Breakpoint = Breakpoint;

(function (Breakpoint) {
  Breakpoint["TINY"] = "tn";
  Breakpoint["SMALL"] = "sm";
  Breakpoint["MEDIUM"] = "md";
  Breakpoint["LARGE"] = "lg";
  Breakpoint["GREAT"] = "gt";
  Breakpoint["HUGE"] = "hg";
})(Breakpoint || (exports.Breakpoint = Breakpoint = {}));